<template>
  <div>
    <!-- <div class="zhuangtailan">
      <img src="../../../assets/nav/yz_nav_fh.png" alt="" @click="goback" />
      <p>免责声明</p>
    </div> -->
    <div class="disclaimer-content">
      <h2>小号托管服务免责声明</h2>
      
      <p>欢迎您使用本小号托管服务（以下简称"本服务"）。在使用本服务前，请您务必仔细阅读并充分理解本免责声明的全部内容。您一旦使用本服务，即表示您已完全接受本声明项下的所有条款和条件。如您不同意本声明，请立即停止使用本服务。</p>
      
      <h3>一、使用此功能须知</h3>
      <ul>
        <li><strong>服务性质说明：</strong>本服务为用户将小号托管至他人（如好友、朋友等）账号下提供相关技术支持，包括但不限于账号关联、基础权限设置等。本服务不保证托管过程中的绝对稳定性，因网络波动、服务器维护、第三方平台政策调整、托管方操作等不可归责于我方的因素导致服务中断、延迟或无法正常使用的，我方不承担赔偿责任。</li>
        <li><strong>用户资格要求：</strong>使用本服务的用户必须为具备完全民事行为能力的自然人，且您对所托管的小号拥有合法的所有权或使用权。如因您提供的小号存在权属争议、违规封禁等问题导致服务无法正常进行或产生损失的，由您自行承担全部责任。</li>
        <li><strong>账号信息安全：</strong>您应自行妥善保管自己的账号、密码等信息，我方仅在提供服务期间出于技术需要临时存储相关信息，且会采取合理的安全措施进行保护。但因您自身原因（如信息泄露、密码过于简单等）或不可抗力因素导致账号被盗、信息泄露的，我方不承担责任。</li>
        <li><strong>服务合规性：</strong>您承诺在使用本服务过程中，严格遵守国家法律法规、第三方平台（如游戏平台、社交平台等）的用户协议及相关规定。不得利用本服务从事任何违法违规、侵权、骚扰他人或损害第三方利益的行为，否则我方有权立即终止服务，且您需承担由此产生的一切法律后果。</li>
      </ul>
      
      <h3>二、角色道具、礼包等功能使用问题</h3>
      <ul>
        <li><strong>道具礼包获取与归属：</strong>托管服务过程中，若小号通过系统任务、活动等方式获得角色道具、礼包、虚拟货币等虚拟财产，其所有权归属于小号账号的合法持有人（即您）。我方不参与、不干预虚拟财产的分配，亦不对此类虚拟财产的数量、质量、有效性等作出任何承诺或保证。</li>
        <li><strong>道具使用风险：</strong>因第三方平台的规则调整（如道具下架、属性修改、活动取消等）、系统漏洞或故障、托管方操作等原因，导致已获取的角色道具、礼包无法正常使用、失效或价值受损的，我方不承担任何赔偿责任。您应自行与托管方约定相关责任，并承担相应风险。</li>
        <li><strong>操作失误免责：</strong>我方在提供托管服务时，将按照预设的合理流程执行操作，但因第三方平台界面更新、操作流程变更、不可预见的技术问题或托管方操作失误，进而影响角色道具、礼包使用的，我方在及时采取补救措施后，不承担其他赔偿责任。托管期间造成的角色财产道具等损失由您自行承担。</li>
        <li><strong>充值权限限制：</strong>托管中的小号，托管人仅拥有游玩操作权限，无权进行充值操作（游戏内虚拟货币的使用除外）。所有涉及小号的充值行为均需由小号账号的合法持有人（即您）本人完成。如因托管人违规尝试充值或您授权托管人充值导致的任何损失，我方不承担责任。</li>
        <li><strong>禁止交易约定：</strong>您不得通过本服务将小号及其中的角色道具、礼包等虚拟财产进行交易、转让、赠与或抵押等行为。如您违反此约定导致账号被封禁、虚拟财产损失等后果的，由您自行承担全部责任。</li>
      </ul>
      
      <h3>三、其他免责条款</h3>
      <ul>
        <li><strong>间接损失免责：</strong>我方对因使用本服务可能产生的间接损失、预期利益损失、精神损害赔偿等不承担任何责任，包括但不限于因服务中断导致的游戏进度延误、社交机会丧失等损失。</li>
        <li><strong>服务修改与终止：</strong>我方有权根据业务发展需要，随时修改、暂停或终止本服务，且将通过合理方式提前通知您。因服务修改、暂停或终止给您造成的损失，我方不承担责任，但会按照公平原则处理已收取的服务费用（如有）。</li>
        <li><strong>法律适用与争议解决：</strong>本免责声明适用中华人民共和国法律（不含港澳台地区法律）。如双方就本声明内容或其执行发生任何争议，应尽量友好协商解决；协商不成的，任何一方均有权向我方所在地有管辖权的人民法院提起诉讼。</li>
      </ul>
      
      <p class="disclaimer-bottom">本免责声明自发布之日起生效，并构成您与我方之间关于使用本小号托管服务的重要法律文件。我方有权根据实际情况对本声明内容进行更新，更新后的声明将在服务页面公示，公示后即对您产生约束力。请您定期关注本声明的更新情况。</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'xhtg_mzsm',
  methods: {
    goback() {
      this.$router.back();
    }
  }
};
</script>
<style scoped>
.zhuangtailan {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  /* margin-left: 32px; */
  padding: 32px;
  box-sizing: border-box;
  background-color: #fff;
  /* 为固定顶部导航栏添加安全区域适配 */
  padding-top: calc(20px + env(safe-area-inset-top));
  padding-top: calc(20px + constant(safe-area-inset-top));
}

.zhuangtailan img {
  width: 60px;
  height: 60px;
}

.zhuangtailan p {
  font-size: 32px;
  font-weight: 700;
  margin: 0;
  text-align: center;
  flex: 1;
  margin-right: 92px;
}

.disclaimer-content {
  padding-top: 30px; /* 为固定导航栏留出空间 */
  padding: 30px 40px 40px;
  font-size: 28px;
  line-height: 1.8;
  color: #333;
}

.disclaimer-content h2 {
  font-size: 36px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin: 0 0 30px 0;
}

.disclaimer-content h3 {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin: 30px 0 20px 0;
}

.disclaimer-content ul {
  padding-left: 20px;
  margin: 0 0 20px 0;
}

.disclaimer-content li {
  margin-bottom: 20px;
  list-style-type: disc;
  text-align: justify;
}

.disclaimer-content strong {
  color: #333;
}

.disclaimer-content p {
  margin: 0 0 20px 0;
  text-align: justify;
}

.disclaimer-bottom {
  margin-top: 40px;
  font-size: 26px !important;
  color: #666 !important;
}
</style>

